module.exports = __webpack_public_path__ + "static/media/Avatars_Male-13.c1b1e52b.png";